export default __webpack_public_path__ + "static/media/food-5865805_1280.e4668a16.png";